import React from "react";
import { MdArrowForward } from "react-icons/md";

import "./blogs_home.css";

const BLOG_HOME_URL = "https://blog.proptechclub.org";

const recentBlogs = [
  {
    title: "Innovation Meets Governance: Landtrack Welcomes Syed Nasir Hussain Shah to Close PropTech '26",
    excerpt:
      "The final day at Karachi Expo Center brought private-sector innovation together with government regulatory leadership.",
    image:
      "https://blog.proptechclub.org/wp-content/uploads/2026/03/Innovation-Meets-Governance-Landtrack-Welcomes-Syed-Nasir-Hussain-Shah-to-Close-PropTech-%E2%80%9826-1.png",
    url: "https://blog.proptechclub.org/2026/03/03/innovation-meets-governance-landtrack-welcomes-syed-nasir-hussain-shah-to-close-proptech-26/",
  },
  {
    title: "The Backbone of Progress: Landtrack & The State Bank Define Day 2 of PropTech '26",
    excerpt:
      "Day 2 focused on the machinery of progress, from secure payments to stronger development standards.",
    image:
      "https://blog.proptechclub.org/wp-content/uploads/2026/03/The-Backbone-of-Progress-Landtrack-The-State-Bank-Define-Day-2-of-PropTech-%E2%80%9826-1.png",
    url: "https://blog.proptechclub.org/2026/03/03/the-backbone-of-progress-landtrack-the-state-bank-define-day-2-of-proptech-26/",
  },
  {
    title: "Organizing the Future: Landtrack Leads Day 1 of PropTech Convention 2026",
    excerpt:
      "A look inside the opening day of PropTech Convention 2026 and the conversations shaping Pakistan's property market.",
    image:
      "https://blog.proptechclub.org/wp-content/uploads/2026/03/Organizing-the-Future-Landtrack-Leads-Day-1-of-PropTech-Convention-2026-1.png",
    url: "https://blog.proptechclub.org/2026/03/03/organizing-the-future-landtrack-leads-day-1-of-proptech-convention-2026/",
  },
];

const BlogsHome = () => {
  return (
    <section id="blogs_home_section" aria-labelledby="blogs_home_hdng">
      <div id="blogs_home_inner">
        <div id="blogs_home_intro">
          <h2 id="blogs_home_hdng">Latest Blogs</h2>
          <a id="blogs_home_view_all" href={BLOG_HOME_URL} target="_blank" rel="noopener noreferrer">
            View All Blogs
            <MdArrowForward aria-hidden="true" />
          </a>
        </div>

        <div id="blogs_home_grid">
          {recentBlogs.map((blog) => (
            <a
              className="blogs_home_card"
              href={blog.url}
              key={blog.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="blogs_home_image">
                <img src={blog.image} alt={blog.title} loading="lazy" />
              </div>
              <div className="blogs_home_card_body">
                <h3>{blog.title}</h3>
                <p>{blog.excerpt}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogsHome;
